'use strict';

/**
 * List of all objects
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('./list');
var EmptyCatalogView = require('modules/collection/views/partials/list-catalog-empty');
var HeaderView = require('./header');

var ObjectListLayout = ListLayout.extend({
    getHeaderViewClass: function () {
        App.CollectionModule.catalogs.setActiveCatalog(this.model.catalog.id);

        return HeaderView;
    },

    getEmptyViewClass: function() {
        return EmptyCatalogView;
    },
});

module.exports = ObjectListLayout;